import { stageIdsForAcceptanceStatuses } from '../config/room';

export const checkHasAcceptanceStatusesData = (data) =>
  data.some((item) => {
    const { addressLifeCycle } = item;

    const stageId = addressLifeCycle?.stageAddressLifeCycle?.id;
    const acceptanceStatusId =
      addressLifeCycle?.acceptanceStatusAddressLifeCycle?.id;

    return stageIdsForAcceptanceStatuses.has(stageId) && acceptanceStatusId;
  });
